"use client";
import Link from "@/components/Link";
import PureCarousel from "@/components/ui/PureCarousel";
import { Paragraph } from "@cgc/ui/typography";
import { clsx } from "@cgc/ui/utils/clsx";
import Image from "next/image";
import React from "react";

import { BlogSidebarItemProps, BlogSidebarProps } from "./types";

const BlogSidebarMobileItem: React.FC<BlogSidebarItemProps> = ({
  url,
  title,
  image,
  alt = "",
  size = 150,
}) => (
  <div className="grid h-full grid-cols-2 space-x-5 px-8">
    <Link href={url} className="w-[150px]">
      <Image src={image} alt={alt} width={size} height={size} />
    </Link>
    <Link href={url} className="flex items-center no-underline">
      <Paragraph
        as={"div"}
        size={"sub2"}
        className="overflow-hidden text-center uppercase"
      >
        {title}
      </Paragraph>
    </Link>
  </div>
);

const BlogSidebarMobile: React.FC<BlogSidebarProps> = ({
  className,
  items,
}) => (
  <div
    className={clsx("bg-cgc-yellow-20 -ml-4 w-screen pb-5 pt-10", className)}
  >
    <PureCarousel controlSize="small" className="mb-0">
      {items.map((item) => (
        <BlogSidebarMobileItem {...item} key={item.url} />
      ))}
    </PureCarousel>
  </div>
);

export default BlogSidebarMobile;
